'use strict';

import React from 'react';
import { CorePipelineProgressSummary } from './CorePipelineProgressSummary';
import { KITS_PROGRESS_COPY } from './pipelineProgressCopy';

/**
 * Kits sample-set tracker: ManifestAvailable forks to portal catalog upsert
 * and to DataNormCompleted → Portal / Pathway / BioVis publication.
 * @param {{
 *   model: import('./pipelineCoreProgressModel').CorePipelineProgressModel,
 *   facts?: import('./pipelineStatusTypes').PipelineStatusFact[],
 *   projectId?: string,
 * }} props
 */
export function KitsPipelineProgressSummary({ model, facts, projectId, definition }) {
	return (
		<CorePipelineProgressSummary
			model={model}
			facts={facts}
			projectId={projectId}
			definition={definition}
			copy={KITS_PROGRESS_COPY}
			testIdPrefix="kits"
			detailKind="kits"
		/>
	);
}
